import React from 'react';
import { SceneCanvas } from '../SceneCanvas';
import { CinematicOverlay } from '../CinematicOverlay';
import { CursorLight } from '../CursorLight';
import { CandleProduct } from '../../types';

interface DesktopExperienceProps {
  scrollProgress: number;
  activeCandleIndex: number;
  setActiveCandleIndex: (idx: number) => void;
  onOpenCart: (candle?: CandleProduct) => void;
  onOpenFounderModal: () => void;
  onOpenCustomizerModal: () => void;
  onScrollToProgress: (target: number) => void;
  onTriggerShopTransition?: () => void;
  onOpenAccount?: () => void;
  cartCount?: number;
}

export const DesktopExperience: React.FC<DesktopExperienceProps> = React.memo((props) => {
  return (
    <div className="relative min-h-[14000px] bg-[#070504] selection:bg-amber-500/30">
      {/* Interactive Light Cursor */}
      <CursorLight />

      {/* 3D WebGL Background Film Canvas - High Performance Desktop */}
      <SceneCanvas
        scrollProgress={props.scrollProgress}
        activeCandleIndex={props.activeCandleIndex}
        onCandleSelect={props.setActiveCandleIndex}
        isMobile={false}
      />

      {/* Wide Cinematic Overlay UI */}
      <CinematicOverlay {...props} />
    </div>
  );
});
